export default __webpack_public_path__ + "static/media/cabinet.5949d242.svg";